import Vue from "vue";
import moment from "moment";
import users from "../users";
import axios from "axios";
import * as utils from "../utils";
import * as files from "../fileUtils";
import CookieLaw from "vue-cookie-law";
import * as VueGoogleMaps from "vue2-google-maps";
import AWN from "awesome-notifications";
import jwtTokenHandler from "@/jwtTokenHandler";

//import '../scss/main-ltr.scss';

//let globalOptions;
//let notifier;

//if (localStorage.getItem('_lang') == 'ar') {
//  //require('../scss/main-rtl.scss');

//  require('../scss/rtl.css')
//  require('../scss/main-rtl.scss')
//}
//else {
//  require('vue-material/dist/vue-material.min.css')
//  require('../scss/main-ltr.scss')

//  //require('../scss/main.scss');
//}

export default {
  name: "App",
  components: {
    AppMessagesComp: require("../common/messages/messages.vue").default,
    CookieLaw,
    InitialPreferences:
      require("@/customcontrols/initialPreferences/initialPreferences.vue")
        .default,
    //HierarchyLinksComp2: require('../common/hierarchyLinks/hierarchyLinks2.vue').default,
  },
  mixins: [users, jwtTokenHandler],
  data: function () {
    return {
      forceShowToolbar: process.env.NODE_ENV === "development",
      portalRunThrouReact: false,
      msgDialogNotificationStack: [],
      isInIframe: false,
      brandPrimaryColor: "",
      brandSecondarytColor: "",
      brandAccentColor: "",
      brandingLoginPrimaryColor: "",
      brandingLoginSecondaryColor: "",

      employeeStationId: -1,
      dashBoards: { allow: false, showOnStart: false },

      isFieldWorker: true,
      okNotificationContent: "",
      okNotificationTitle: "",
      okNotificationDialogShow: false,

      displayNotificationDialog: false,
      notificationMessage: "",
      notificationTitle: "",
      dismissableNotification: true,
      notificationIcon: "close",
      notificationProgress: 0,
      notificationIconType: 4,
      keepNotification: false,
      notificationTimeDisplay: 0,

      windowDimensions: {
        height: window.innerHeight,
        width: window.innerWidth,
      },
      isMobileDevice: true,
      bShowSecurities: true,
      bExistPdfManual: false,
      portalName: "Edams",
      pageTitle: "",
      unreadMsgCount: 0,
      messagesData: null,
      msgTimer: null,
      googleMapsApiKey: "",
      settings: { logo: null, orgName: "", orgShortName: "", paymentLink: "" },
      jcc: {
        applicationId: 0,
        typeId: 0,
      },
      oidcModel: {
        account: "",
        idNo: "",
        email: "",
        name: "",
        surname: "",
        cellTelNo: "",
      },
      languages: [],
      showSidepanel: false,
      showNavigation: false,
      bShowUnreadMessages: false,
      currencySymbol: "€",
      defaultLanguage: "en",
      bSelectAccount: true,
      bShowElementExternalRef: false,
      bShowElementLogDescription: true,
      bShowElementLogExternalRef: false,
      bShowElementUserRef: true,
      bShowTermsAndConditions: false,
      bValidateCustomerAccountEmail: true,
      bValidateCustomerAccountIdNo: true,
      bValidateCustomerAccountMobileNo: false,
      menuItems: [],
      menuItemsBCRM: [],
      menuItemseFWM: [],
      menuItemsMMS: [],
      bCRMCounter: 0,
      eFWMCounter: 0,
      MMSCounter: 0,
      portalAuthenticationType: 0,
      profileStatus: -1,
      bIsCustomerApplications: false,
      bIsCustomerBillingPortal: false,

      hierarchyLinksItems: [],
      renderKey: 0,
      treeIdx: 0,
      HierarchyKey: 0,
      hierarchyLinks: [],
      loginStyleClass: true,
      loginBgImage: "",
      webPortalUrl: "",
    };
  },
  computed: {
    brandingColor() {
      return {
        "background-color": `${this.settings.brandingColor} !important`,
      };
    },
    brandingSecondaryColor() {
      return {
        "background-color": `${this.settings.brandingSecondaryColor} !important`,
      };
    },
    brandingSecondaryColorText() {
      return { color: `${this.settings.brandingSecondaryColor} !important` };
    },
    brandingAccentColorText() {
      return { color: `${this.settings.brandingAccentColor} !important` };
    },
    brandingLoginSecondaryColorText() {
      return { color: `${this.settings.brandingLoginPrimaryColor} !important` };
    },
    appStyle: function () {
      return "width:" + this.windowDimensions.width + ";";
    },
    userMenu: function () {
      return utils.getMenuItems(this.user, this.roles);
    },
    langSrc: function (langId) {
      return "/static/images/" + langId + ".png";
    },
    iFrameAndAuthReady: function () {
      return this.isInIframe && this.user.authenticated;
    },
  },
  watch: {
    showNavigation: function (value) {
      if (value === true && this.menuItems.length === 0) {
        this.getProfileDetails();
      }
    },
    userAuthenticated: function (value) {
      if (value) {
        if (this.user.role == this.roles.Customer) {
          setTimeout(() => {
            this.getUnreadMsgCount();
          }, 3000);
          this.msgTimer = setInterval(() => {
            this.getUnreadMsgCount();
          }, 60000);
        }
      } else {
        if (this.msgTimer != null) clearInterval(this.msgTimer);
      }
    },
    $route(to, from) {
      if (to.name == "login") this.loginStyleClass = true;
      else this.loginStyleClass = false;
    },
    webPortalUrl: function (value) {
      if (value !== "" && this.isInIframe) {
        this.manageMessagesFromParentSite();
      }
    },
    iFrameAndAuthReady: function (value) {
      if (value) {
        this.$router.beforeEach((to, from, next) => {
          this.loginStyleClass = false;

          this.applicationPageCheck(to, from);

          if (this.$t)
            this.pageTitle =
              this.portalName + " - " + this.$t("routes." + to.name);
          if (to.name === "confirmLink" && from.name === "confirmLink")
            to.params = from.params;
          if (to.name === "resetPassword" && from.name === "resetPassword")
            to.params.code = from.params.code;
          else if (
            to.meta.requiresAuth &&
            (!this.user || !this.user.authenticated)
          ) {
            this.loginStyleClass = true;
            next("/login");
          } else if (
            to.name === "login" &&
            this.user &&
            this.user.authenticated
          ) {
            this.getElementTypesPlain();
            next("/employeeHome");
          } else next();
        });
      }
    },
    displayNotificationDialog: function (value) {
      if (!value) this.notificationDialogOff();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.setDateFormat();
      this.windowDimensionCheck();
      window.addEventListener("resize", () => {
        this.windowDimensionCheck();
      });
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);

    if (this.isInIframe) {
      window.removeEventListener("load", this.sendHightToParent);
    }
  },
  created() {
    this.$root.$on("user_loggedin", this.getProfileDetails);

    this.isInIframe = window.self !== window.top;
    if (this.isInIframe) {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get("token");
      this.saveJwtToken(token);

      // this.$localStorage.set('token', token);
      // this.registerAxiosInterceptors(token);

      urlParams.delete("token");
      this.$router.replace({
        path: window.location.pathname,
        query: Object.fromEntries(urlParams),
      });

      this.createFunctions();
      this.manageMessagesFromParentSite();
    } else {
      // Check for existing JWT token and register interceptors on app startup
      this.checkForJwtToken();
      this.createFunctions();
    }
  },
  methods: {
    applicationPageCheck(to, from) {
      //leaving application, unlock app.
      if (from.name == "application" && to.name != "application")
        this.unlockApplication(this.$store.getters.getCurrentAppIdOpened);
    },
    async prepareForNewPortal() {
      this.$store.commit("setEnableOfflineApplications", true);

      this.$root.$on("display_ok_notification", (title, content) =>
        this.okNotificationDialog(title, content)
      );
      this.$root.$on(
        "display_alert_dialog_window",
        this.addToMessageDialogStack
      );

      if (this.$localStorage.get("orgSettings") != null)
        this.settings = this.$localStorage.get("orgSettings");

      const token = this.$localStorage.get("token");
      if (token !== null) {
        axios.defaults.headers.common = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
      }

      this.$root.$on("get_org_settings", () =>
        this.$root.$emit("return_org_settings", this.settings)
      );
      await this.getOrganisationSettings();
      await this.getSettings();

      this.$root.$on("user_loggedin", this.login);

      this.existPdfManual();

      if (!this.userAuthenticated) await this.getUserDetails();

      this.initNotifierGlobalOptions();
      this.$store.commit("initCsPouchDB", null);
      this.$store.commit("initReadingsPouchDB", null);
      this.$store.commit("initDebtManagementLocalDB", null);
      //setInterval(this.checkSessionCookie, 60000);

      if (!this.isInIframe) {
        this.getHierarchyLinks();
      }

      this.$router.beforeEach((to, from, next) => {
        this.loginStyleClass = false;

        this.applicationPageCheck(to, from);

        if (this.$t)
          this.pageTitle =
            this.portalName + " - " + this.$t("routes." + to.name);
        if (to.name === "confirmLink" && from.name === "confirmLink")
          to.params = from.params;
        if (to.name === "resetPassword" && from.name === "resetPassword")
          to.params.code = from.params.code;
        else if (
          to.meta.requiresAuth &&
          (!this.user || !this.user.authenticated)
        ) {
          this.loginStyleClass = true;
          next("/login");
        } else if (
          to.name === "login" &&
          this.user &&
          this.user.authenticated
        ) {
          this.getElementTypesPlain();
          next("/employeeHome");
        } else next();
      });
    },
    createFunctions() {
      const token = this.$localStorage.get("token");
      if (token !== null) {
        axios.defaults.headers.common = {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        };
      }

      this.$store.commit("setEnableOfflineApplications", true);

      this.$root.$on("display_ok_notification", (title, content) =>
        this.okNotificationDialog(title, content)
      );
      this.$root.$on(
        "display_alert_dialog_window",
        this.addToMessageDialogStack
      );

      if (this.$localStorage.get("orgSettings") != null)
        this.settings = this.$localStorage.get("orgSettings");

      this.$root.$on("get_org_settings", () =>
        this.$root.$emit("return_org_settings", this.settings)
      );
      this.getOrganisationSettings();
      this.getSettings();

      if (this.isInIframe) {
        this.$router.beforeEach((to, from, next) => {
          this.loginStyleClass = false;

          this.applicationPageCheck(to, from);

          if (this.$t) {
            this.pageTitle =
              this.portalName + " - " + this.$t("routes." + to.name);
          }

          if (to.name === "confirmLink" && from.name === "confirmLink") {
            to.params = from.params;
            return next(); // ✅ Ensure we exit after calling next()
          }

          if (to.name === "resetPassword" && from.name === "resetPassword") {
            to.params.code = from.params.code;
            return next(); // ✅ Ensure we exit after calling next()
          }

          if (
            to.meta.requiresAuth &&
            (!this.user || !this.user.authenticated)
          ) {
            this.loginStyleClass = true;
            return next("/login"); // ✅ Ensure we exit after calling next()
          }

          if (to.name === "login" && this.user && this.user.authenticated) {
            this.getElementTypesPlain();
            return next("/employeeHome"); // ✅ Ensure we exit after calling next()
          }

          next(); // Default case ✅
        });
      } else {
        //setInterval(this.checkSessionCookie, 60000);

        this.$router.beforeEach((to, from, next) => {
          if (
            from.name &&
            from.name.toLowerCase() === "resetpassword" &&
            to.name &&
            to.name.toLowerCase() === "login"
          ) {
            return;
          }

          this.loginStyleClass = false;

          this.applicationPageCheck(to, from);

          if (this.$t)
            this.pageTitle =
              this.portalName + " - " + this.$t("routes." + to.name);

          if (to.name === "confirmLink" && from.name === "confirmLink")
            to.params = from.params;
          if (to.name === "resetPassword" && from.name === "resetPassword")
            to.params.code = from.params.code;
          else if (
            to.meta.requiresAuth &&
            (!this.user || !this.user.authenticated) &&
            !(to.name == "applications" && from.name == "check")
          ) {
            this.loginStyleClass = true;
            next("/login");
          } else if (
            to.name === "login" &&
            this.user &&
            this.user.authenticated
          ) {
            this.getElementTypesPlain();
            next("/employeeHome");
          } else if (
            (to.name === "applications" && from.name === "omActivities") ||
            (to.name === "omActivities" && from.name === "applications")
          ) {
            window.location.pathname = `${to.name}`;
          } else next();
        });
      }

      this.$root.$on("user_loggedin", this.login);

      this.existPdfManual();

      if (!this.isInIframe) {
        if (!this.userAuthenticated) this.getUserDetails();
      }

      this.initNotifierGlobalOptions();
      this.$store.commit("initCsPouchDB", null);
      this.$store.commit("initReadingsPouchDB", null);
      this.$store.commit("initDebtManagementLocalDB", null);

      if (!this.isInIframe) {
        this.getHierarchyLinks();
      }
    },
    manageMessagesFromParentSite() {
      const receiveMessage = (event: MessageEvent) => {
        if (event.data.type === "SET_TOKEN") {
          const { token, page, email, lang } = event.data.payload;
          // this.$localStorage.set('token', token);
          // axios.interceptors.request.use(
          //   (config) => {
          //     config.headers.Authorization = `Bearer ${token}`; // Set Authorization header
          //     config.headers['Content-Type'] = 'application/json'; // Set Content-Type header
          //     return config;
          //   },
          //   (error) => {
          //     return Promise.reject(error);
          //   }
          // );

          this.$i18n.locale = lang;
          this.prepareForNewPortal();
          this.$localStorage.set("_login", email);
          this.$root.$emit("user_loggedin");
        }
      };

      window.addEventListener("message", receiveMessage);

      window.addEventListener("load", (event) => {
        this.sendHightToParent();

        const observer = new MutationObserver(this.sendHightToParent);
        observer.observe(document.body, { childList: true, subtree: true });
      });
    },
    sendHightToParent() {
      if (!this.isInIframe || this.webPortalUrl === "") return;
      window.parent.postMessage(
        { type: "IFRAME_HEIGHT", payload: document.body.scrollHeight },
        this.webPortalUrl
      );
    },
    disableLoginButton(date) {
      this.$store.commit("setDisableLoginButtonDate", date);
      this.$store.commit(
        "setDisableLoginButtonDescription",
        `${this.$t("common.LoginDisabled")} ${moment(date)
          .locale(this.$i18n.locale)
          .format("Do MMMM ")}`
      );

      axios
        .post("/Utility/GetMessage", { Lang: this.$i18n.locale, TextId: 112 })
        .then((response) => {
          if (response.data.data.status == 0)
            this.$store.commit(
              "setDisableLoginButtonText",
              response.data.settings.text ?? null
            );
        });
    },
    setDateFormat() {
      let dteFrmt = this.getLocaleDateString();

      this.$store.commit("setDateFormat", dteFrmt.replaceAll("d", "D"));
      this.$store.commit("setMaterialDateFormat", dteFrmt);

      this.$material.locale.dateFormat = dteFrmt;
    },
    getLocaleDateString() {
      return "dd/MM/yyyy";
      //return formats[navigator.language] || "dd/MM/yyyy";
    },
    okNotificationDialog(title, content) {
      this.okNotificationTitle = title;
      this.okNotificationContent = content;
      this.okNotificationDialogShow = true;
    },
    errorLog(msg, color) {
      console.groupCollapsed(
        "%c==> " + msg,
        "color: " +
          color +
          "; font-style: italic; background-color: black;padding: 2px"
      );
      console.trace();
      console.groupEnd();
    },
    async addToMessageDialogStack(input) {
      if (this.displayNotificationDialog) {
        this.msgDialogNotificationStack.push(input);
      } else this.displayNotificationDialogFunc(input.message, input.type);
    },
    async displayNotificationDialogFunc(msg, type) {
      this.keepNotification = false;

      switch (type) {
        default:
        case "error":
        case 4:
          this.dismissableNotification = false;
          this.notificationTitle = this.$t("notifications.labels.alert");
          this.notificationIcon = "close";
          this.notificationIconType = 4;
          this.notificationTimeDisplay = 0; // in miliseconds
          this.errorLog(msg, "red");
          break;
        case "warning":
        case 3:
          this.dismissableNotification = true;
          this.notificationTitle = this.$t("notifications.labels.warning");
          this.notificationIcon = "warning_amber";
          this.notificationIconType = 3;
          this.notificationTimeDisplay = 40; // in miliseconds
          this.errorLog(msg, "yellow");
          break;
        case "success":
        case 2:
          this.dismissableNotification = true;
          this.notificationTitle = this.$t("notifications.labels.success");
          this.notificationIcon = "check_circle";
          this.notificationIconType = 2;
          this.notificationTimeDisplay = 5; // in miliseconds
          break;
        case "info":
        case 1:
          this.dismissableNotification = true;
          this.notificationTitle = this.$t("notifications.labels.info");
          this.notificationIcon = "info";
          this.notificationIconType = 1;
          this.notificationTimeDisplay = 15; // in miliseconds
          break;
      }
      this.$forceUpdate();

      this.notificationMessage = msg;
      this.displayNotificationDialog = true;

      if (!this.dismissableNotification) return;

      this.notificationProgress = 0;

      const delay = (ms) => new Promise((res) => setTimeout(res, ms));
      for (let i = 0; i < 100; i++) {
        if (!this.displayNotificationDialog || this.keepNotification) {
          this.notificationProgress = 100;
          break;
        }
        this.notificationProgress++;
        await delay(this.notificationTimeDisplay);
      }

      if (!this.keepNotification) this.notificationDialogOff();
    },
    notificationDialogOff() {
      this.displayNotificationDialog = false;

      if (
        this.msgDialogNotificationStack &&
        this.msgDialogNotificationStack.length > 0
      ) {
        let input = this.msgDialogNotificationStack.shift();
        this.displayNotificationDialogFunc(input.message, input.type);
      }
    },
    notificationDialogClicked() {
      this.keepNotification = true;
    },
    windowDimensionCheck() {
      this.windowDimensions = {
        height: window.innerHeight,
        width: window.innerWidth,
      };
      if (this.windowDimensions.width <= 915) this.isMobileDevice = true;
      else this.isMobileDevice = this.isMobileDeviceCheck();
    },
    isMobileDeviceCheck() {
      //Storing user's device details in a variable
      let details = navigator.userAgent;

      //Creating a regular expression containing some mobile devices keywords to search it in details string
      let regexp = /android|iphone|kindle|ipad/i;

      //Using test() method to search regexp in details it returns boolean value
      return regexp.test(details);

      //check window orientation, if -1 desktop
      //depreciated method
      //return window.orientation > -1;
    },
    getBackgroundImageStyle() {
      let res = "";

      if (this.loginBgImage != "" && this.loginStyleClass) {
        res = "backgroundImage: url(" + this.loginBgImage + ")";
      }

      return res;
    },
    getCopyrightMessage() {
      var year = new Date();
      return "Copyright Hydro-Comp Enterprises Ltd, " + year.getFullYear();
    },
    getProfileStatus() {
      axios.post("/account/GetProfileStatus").then((response) => {
        if (response.data.data.status == 0) {
          this.profileStatus = response.data.status;
          if (this.profileStatus === 0) this.login();
          else {
            //if (this.profileStatus === 1)
            var userEmail = response.data.userEmail;

            if (userEmail && userEmail.length > 0) {
              this.$localStorage.set("_login", userEmail);
              this.$root.$emit("user_loggedin");
            }
          }
        }
      });
    },
    existPdfManual() {
      axios
        .post("/Utility/IsExistingLocalizedFile", { Value: 1 })
        .then((response) => {
          if (response.data.data.status === 0) {
            this.bExistPdfManual = response.data.isExisting;
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((e) => {
          this.$router.push("/login");
          return false;
        });
    },
    getPdfManual() {
      axios
        .post("/Utility/IsExistingLocalizedFile", { Value: 1 })
        .then((response) => {
          if (
            response.data.data.status === 0 &&
            response.data.isExisting === true
          ) {
            this.download(1);
          } else if (
            response.data.data.status === 0 &&
            response.data.isExisting === false
          ) {
            this.okNotificationDialog(
              this.$t("investigationDetail.Warning"),
              this.$t("messages.PdfHelpFileDoesNotExist")
            );
          } else {
            this.$alertMsg(response.data.data.text);
          }
        })
        .catch((e) => {
          this.$router.push("/login");
          return false;
        });
    },
    download(id) {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post(
          "/Utility/DownloadLocalizedFile",
          { Value: id },
          { responseType: "blob" }
        )
        .then((response) => {
          files.getFile(response);
        })
        .then((response) => {
          loader.hide();
        })
        .catch((err) => {
          loader.hide();
          console.error(err);
        });
    },
    startTourGuide() {
      if (this.$tours["portalTour"]) this.$tours["portalTour"].start();
    },
    getLangImage(langCode) {
      return require(`/src/assets/images/${langCode}.png`);
    },
    getHelpImage(sImg) {
      return require(`/src/assets/images/${sImg}.png`);
    },
    async checkSessionCookie() {
      if (this.$store.state.csAppsOfflineMode) return false;

      return await axios
        .post("/account/GetProfileDetails")
        .then((response) => {
          this.$store.commit("setUserProfile", response.data.item);

          if (response.data.item.isFieldWorker)
            this.$store.commit("setIsFieldWorker", true);
          else this.$store.commit("setIsFieldWorker", false);
          // do nothing - this is function is on minute interval to redirect to login when session cookie gets expired

          this.$store.commit("setUserProfile", response.data.item);

          let temp = response.data.item.employeeStationId;

          if (temp != this.employeeStationId)
            this.$root.$emit("employee_station_updated", temp);

          this.employeeStationId = temp;

          return response.data.item.isFieldWorker;
        })
        .catch((e) => {
          if (this.$parent && this.$parent.user)
            this.$parent.user.authenticated = false;
          if (window.location.pathname != "/login") this.$router.push("/login");

          return false;
        });
    },
    getProfileDetails() {
      axios
        .post("/account/GetProfileDetails")
        .then(async (response) => {
          this.$store.commit("setUserProfile", response.data.item);

          //add flag for field worker user
          //this.user['isFieldWorker'] = response.data.item.isFieldWorker;

          if (response.data.data.status == 0) {
            if (
              response.data.item.isFieldWorker &&
              !response.data.item.portalMaintenanceCrmFull
            )
              this.$store.commit("setIsFieldWorker", true);
            else this.$store.commit("setIsFieldWorker", false);

            var resp = response.data.item;

            this.isFieldWorker = response.data.item.isFieldWorker;
            this.portalNewCs =
              resp.portalNewCs && resp.portalNewCs == true ? true : false;
            this.portalOm =
              resp.portalOm && resp.portalOm == true ? true : false;
            this.portalDisconnections =
              resp.portalDisconnections && resp.portalDisconnections == true
                ? true
                : false;
            this.portalDm =
              resp.portalDm && resp.portalDm == true ? true : false;
            this.portalDmControlPanel =
              resp.dmControlPanel && resp.dmControlPanel == true ? true : false;
            this.portalElements =
              resp.elementProperties && resp.elementProperties == true
                ? true
                : false;
            this.portalAssetRegister =
              resp.assetRegister && resp.assetRegister == true ? true : false;
            this.portalConditionAssessment =
              resp.conditionAssessment && resp.conditionAssessment == true
                ? true
                : false;
            this.portalLogs =
              resp.portalLogs && resp.portalLogs == true ? true : false;
            this.portalQuality =
              resp.portalQuality && resp.portalQuality == true ? true : false;
            this.portalCmrAdmin =
              resp.portalCaptureMeterReadingsAdmin &&
              resp.portalCaptureMeterReadingsAdmin == true
                ? true
                : false;
            if (this.portalCmrAdmin == true)
              this.portalCaptureMeterReadings = false;
            else
              this.portalCaptureMeterReadings =
                resp.portalCaptureMeterReadings &&
                resp.portalCaptureMeterReadings == true
                  ? true
                  : false;
            this.portalGis =
              resp.portalGis && resp.portalGis == true ? true : false;
            this.portalGisAdmin =
              resp.portalGisAdmin && resp.portalGisAdmin == true ? true : false;
            this.portalReceiping =
              resp.portalReceiping && resp.portalReceiping == true
                ? true
                : false;
            this.portalReceipingSessions =
              resp.portalReceipingSessions &&
              resp.portalReceipingSessions == true
                ? true
                : false;
            this.portalMaintenanceCrm =
              resp.portalMaintenanceCrm && resp.portalMaintenanceCrm == true
                ? true
                : false;
            this.portalBilling =
              resp.billing && resp.billing == true ? true : false;
            this.portalDmAgreements =
              resp.portalDmAgreements && resp.portalDmAgreements == true
                ? true
                : false;

            var user = { role: resp.role, authenticated: true };
            this.menuItems = utils.getMenuItems(user, this.roles);
            this.menuItems.shift();

            if (this.portalNewCs == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "applications"
              );
              //this.menuItems = this.menuItems.filter(item => item.id != 'enquiries');
            }
            if (
              this.isFieldWorker ||
              (!this.isFieldWorker &&
                !this.portalNewCs &&
                !this.portalDisconnections &&
                !this.portalCmrAdmin &&
                !this.portalDmAgreements &&
                !this.portalReceiping &&
                !this.portalReceipingSessions &&
                !this.portalBilling &&
                !this.portalDmControlPanel &&
                !this.portalCaptureMeterReadingsAdmin)
            ) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "enquiries"
              );
            }
            if (this.portalOm == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "omApplications"
              );
            }
            if (this.portalDisconnections == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "disconnections"
              );
            }
            if (this.portalDm == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.name != "Dm"
              );
            }
            if (this.portalDmControlPanel == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "dmControlPanel"
              );
            }
            if (this.portalElements == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "elements"
              );
            }
            if (this.portalAssetRegister == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "assets"
              );
            }
            if (this.portalConditionAssessment == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "conditionAssessment"
              );
            }
            if (this.portalLogs == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "logs"
              );
            }
            if (this.portalQuality == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "samples"
              );
            }
            if (this.portalCaptureMeterReadings == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "captureMeterReadings"
              );
            }
            if (this.portalGis == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "webgis"
              );
            }
            if (this.portalGisAdmin == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "gisAdministration"
              );
            }
            if (this.portalReceiping == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "receipting"
              );
            }
            if (this.portalReceipingSessions == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "sessions"
              );
            }
            if (this.portalMaintenanceCrm == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "omActivities"
              );
            }
            if (this.portalBilling == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "billing"
              );
            }
            if (this.portalDmAgreements == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "agreements"
              );
            }
            var link = this.settings.paymentLink;
            if (!link || link === "") {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "billPayment"
              );
            }
            if (this.portalCmrAdmin == false) {
              this.menuItems = this.menuItems.filter(
                (item) => item.id != "cmrAdmin"
              );
            }

            /* Applications Grouping (drawer) */
            for (let i = 0; i < this.menuItems.length; i++) {
              if (this.menuItems[i].id == "omActivities") {
                this.MMSCounter++;
                this.menuItemsMMS.push(this.menuItems[i]);
              }
              if (
                this.menuItems[i].id == "omApplications" ||
                this.menuItems[i].id == "assets" ||
                this.menuItems[i].id == "conditionAssessment" ||
                this.menuItems[i].id == "logs" ||
                this.menuItems[i].id == "samples"
              ) {
                //GROUP eFWM
                this.eFWMCounter++;
                this.menuItemseFWM.push(this.menuItems[i]);
              }
              if (
                this.menuItems[i].id == "applications" ||
                this.menuItems[i].id == "enquiries" ||
                this.menuItems[i].id == "disconnections" ||
                this.menuItems[i].id == "receipting" ||
                this.menuItems[i].id == "sessions" ||
                this.menuItems[i].id == "agreements" ||
                this.menuItems[i].id == "captureMeterReadings" ||
                this.menuItems[i].id == "dmControlPanel" ||
                this.menuItems[i].id == "billing" ||
                this.menuItems[i].id == "cmrAdmin"
              ) {
                //GROUP eFWM
                this.bCRMCounter++;
                this.menuItemsBCRM.push(this.menuItems[i]);
              }

              if (this.menuItems[i].name == "Dm") {
                //change in app.ts L568, dashboards.ts L294 and dms.ts L250
                if (this.isFieldWorker == true)
                  this.menuItems[i].id = "debtManagementSelectBatch";
                this.bCRMCounter++;
                this.menuItemsBCRM.push(this.menuItems[i]);
              }
            } /* End Application Grouping (drawer) */
            await this.$store.commit("setUserProfile", response.data.item);
            this.$root.$emit("profile_details_updated");
          } else {
            this.$parent.user.authenticated = false;
            this.loginStyleClass = true;
            this.$router.push("/login");
          }
        })
        .catch((e) => {
          if (this.$parent && this.$parent.user)
            this.$parent.user.authenticated = false;
          this.$router.push("/login");
        });
    },
    open(ref) {},
    close(ref) {},
    logout() {
      axios
        .post("/account/Logout")
        .then((response) => {
          this.deleteJwtToken();

          this.$store.commit("setUserProfile", {});
          this.user.authenticated = false;
          this.$localStorage.set("_login", null);
          this.$localStorage.set("_preference", null);
          this.$localStorage.set("_property", null);
          this.resetUserDetails();
          this.$router.push("/login");
          this.loginStyleClass = true;
          window.location.reload();
        })
        .catch((e) => {
          this.$router.push("/login");
        });
    },
    async login(event) {
      if (event) event.preventDefault();
      await this.getUserDetails();
      this.getHierarchyLinks();
      this.getElementTypesPlain();
    },
    getUnreadMsgCount() {
      if (this.$store.state.csAppsOfflineMode) return;

      if (this.user && this.user.authenticated) {
        axios
          .post("/ApplicationMessage/GetUnreadItemsCount")
          .then((response) => {
            if (response.data.data.status == 0) {
              this.unreadMsgCount = response.data.count;
            }
          })
          .catch((e) => {
            this.$router.push("/login");
          });
      } else this.unreadMsgCount = 0;
    },
    showUnreadMessages() {
      this.bShowUnreadMessages = true;
      this.messagesData = {
        appId: -1,
        mimeTypes:
          "image/png,image/jpeg,application/pdf,application/msword,application/excel",
        multiple: false,
        permissions: { add: false },
      };
      Vue.nextTick(
        function () {
          this.$root.$emit("unread_messages_updated");
        }.bind(this)
      );
    },
    closeDialog() {
      this.messagesData = null;
      this.bShowUnreadMessages = false;
      this.getUnreadMsgCount();
    },
    setLang(lang, byUser) {
      this.$localStorage.set("fav_language", lang);
      this.$i18n.locale = lang;
      this.setLanguage(lang, byUser);

      if (
        this.$store.getDisableLoginButton &&
        this.$store.getDisableLoginButton.date
      )
        this.disableLoginButton(this.$store.getDisableLoginButton.date);

      this.$root.$emit("lang_changed");
      location.reload();
    },
    async getOrganisationSettings() {
      await axios.post("/Utility/GetOrganisationSettings").then((response) => {
        if (response.data.data.status == 0) {
          this.settings = response.data.settings;
          this.loginBgImage = response.data.settings.loginBackgroundImage;

          let temp = { ...this.settings };
          delete temp.logo;
          delete temp.applicationsIcon;
          delete temp.attachmentsIcon;
          delete temp.billPaymentIcon;
          delete temp.dashScreenIcon;
          delete temp.emailsIcon;
          delete temp.transactionsIcon;
          delete temp.accountIcon;
          delete temp.meterReadingsIcon;
          delete temp.loginBackgroundImage;

          this.disableLoginButton(this.settings.disableLoginDate);

          this.$localStorage.set("orgSettings", JSON.stringify(temp));
          this.settings.orgName =
            this.$t("HomeHome") + " - " + this.settings.orgName;
          this.brandPrimaryColor = this.settings.brandingColor;
          this.brandSecondaryColor = this.settings.brandingSecondaryColor;
          this.brandingLoginPrimaryColor =
            this.settings.brandingLoginPrimaryColor;
          this.brandingLoginSecondaryColor =
            this.settings.brandingLoginSecondaryColor;
          this.brandAccentColor = this.settings.brandingAccentColor;

          this.$localStorage.set("brandingColor", this.settings.brandingColor);
          this.$localStorage.set(
            "brandingSecondaryColor",
            this.settings.brandingSecondaryColor
          );
          this.$localStorage.set(
            "brandingAccentColor",
            this.settings.brandingAccentColor
          );
          this.$localStorage.set(
            "brandingLoginPrimaryColor",
            this.settings.brandingLoginPrimaryColor
          );
          this.$localStorage.set(
            "brandingLoginSecondaryColor",
            this.settings.brandingLoginSecondaryColor
          );

          //this.settings.shortOrgName = 'LWB'; //TBI
          //this.$localStorage.set('orgSettings', JSON.stringify(this.settings));
          if (!this.isInIframe) {
            if (this.user.authenticated) this.getProfileDetails();
          }
        }
      });
    },
    async getSettings() {
      await this.$store
        .dispatch("getUtilitySettings")
        .then(async (response) => {
          if (response.isValid) {
            this.languages = response.languages;
            this.portalName = response.portalName;
            this.pageTitle = this.portalName;

            this.currencySymbol = response.currencySymbol;
            this.defaultLanguage = response.defaultLanguage;
            this.bSelectAccount = response.isSelectAccount;

            this.bValidateCustomerAccountEmail =
              response.isValidateCustomerAccountEmail;
            this.bValidateCustomerAccountIdNo =
              response.isValidateCustomerAccountIdNo;
            this.bValidateCustomerAccountMobileNo =
              response.isValidateCustomerAccountMobileNo;

            this.portalAuthenticationType = response.portalAuthenticationType;
            this.bIsCustomerApplications = response.isCustomerApplications;
            this.bIsCustomerBillingPortal = response.isCustomerBillingPortal;

            this.googleMapsApiKey = response.googleMapsAPIKey;
            //if (this.googleMapsApiKey.length === 0)
            //this.$alertMsg('Invalid Google Map API Key');
            //this.googleMapsApiKey = 'AIzaSyDrc9okYRYhkWwAeavICKZdDKqcTyZ8TUo';

            let filedWorker = await this.checkSessionCookie();
            this.dashBoards.allow = filedWorker
              ? false
              : response.allowDashboardsEmployee;
            this.dashBoards.showOnStart =
              response.showDashboardsOnStartScreenEmployee;

            if (this.googleMapsApiKey.length !== 0) {
              Vue.use(VueGoogleMaps, {
                load: {
                  key: this.googleMapsApiKey,
                  libraries: "places,drawing,visualization,geometry",
                },
              });
            }

            if (!this.isInIframe) {
              var lang = this.$localStorage.get("fav_language");
              if (lang && lang.length > 0) this.setLanguage(lang);
              else this.setLang(this.defaultLanguage);
            }

            this.webPortalUrlwebPortalUrl =
              process.env.NODE_ENV === "production"
                ? response.webPortalUrl
                : "http://localhost:3000";

            this.portalRunThrouReact =
              response.webPortalUrl != null && response.webPortalUrl != "";
          }
        });
    },
    setLanguage(locale, byUser) {
      axios
        .post("/Utility/SetLanguage", {
          LanguageCode: locale,
          UpdateProfile: byUser,
        })
        .catch(function (error) {
          this.$alertMsg(`${this.$t("app.errorChangeLanguage")}` + " " + error);
        });
    },
    payBill() {
      var link = this.settings.paymentLink; // 'https://www.jccsmart.com/e-bill/11853017'
      if (link && link != "") window.open(link, "_blank");
    },
    initNotifierGlobalOptions() {
      let globalOptions = {
        position:
          this.$localStorage.get("fav_language") == "ar"
            ? "bottom-left"
            : "bottom-right",
        labels: {
          tip: this.$t("notifications.labels.tip"),
          info: this.$t("notifications.labels.info"),
          success: this.$t("notifications.labels.success"),
          warning: this.$t("notifications.labels.warning"),
          alert: this.$t("notifications.labels.alert"),
          async: this.$t("notifications.labels.async"),
          confirm: this.$t("notifications.labels.confirm"),
          confirmOk: this.$t("notifications.labels.confirmOk"),
          confirmCancel: this.$t("notifications.labels.confirmCancel"),
        },
      };

      this.$store.commit("initNotifier", { options: globalOptions });
    },

    getHierarchyLinks() {
      //return;
      if (this.$store.state.hierarchyLinksLoaded) return;

      return axios
        .get("Element/GetHierarchyLinks?elementTypeId=-1")
        .then((response) => {
          this.$store.commit("setHierarchyLinks", {
            links: response.data,
            options: {
              dnd: false,
              checkbox: false,
            },
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async populateTree() {
      this.iCurrentCount = 0;
      this.hierarchyLinksItems = [];
      this.hierarchyLinks.forEach(async (item) => {
        await this.sleep(1);
        this.hierarchyLinksItems.push(this.createNodeTree(item));
      });
      this.HierarchyKey++;

      this.$store.commit("setHierarchyLinks", {
        links: this.hierarchyLinksItems,
        options: {
          dnd: false,
          checkbox: false,
        },
      });
    },
    sleep(tm: number): Promise<void> {
      return new Promise<void>((resolve) => {
        setTimeout(resolve, tm);
      });
    },
    createNodeTree(assetNode) {
      this.treeIdx++;

      var node = {
        id: this.treeIdx,
        text: assetNode.Name,
        data: {
          id: this.getUniqueId(),
          elementId: assetNode.ElementId,
          elementTypeId: assetNode.ElementTypeId,
        },
        items: [],
        state: {
          selected: false,
          selectable: true,
          checked: false,
          expanded: this.bExpandNodes,
          disabled: false,
          visible: true,
          indeterminate: false,
          matched: false,
          editable: true,
          dragging: false,
          draggable: true,
          dropable: true,
        },
      };
      //assetNode.Children.forEach(item => {
      //  node.items.push(this.createNodeTree(item));
      //});

      return node;
    },
    getUniqueId() {
      return this.iCurrentCount++;
    },
    openEnquires() {
      if (this.$route.name == "") return;

      window.open("/enquiries", "_blank");
    },
    getQueries() {
      axios
        .get("/CustomQuery/GetQueries?locationId=4")
        .then((response) => {
          if (response.data.data.status == 0) {
          }
        })
        .catch((error) => {
          this.$alertMsg(error.data.data.text);
        });
    },
    getElementTypesPlain() {
      if (!this.checkSessionCookie()) return;

      axios
        .get("/Element/GetElementTypesPlain")
        .then((response) => {
          if (response.status == 200) {
            this.$store.commit("setElementTypesPlain", response.data.items);
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((errpr) => {
          console.log("Error in 'getElementTypesPlain' method: ", errpr);
          //if (errpr.includes == 401) return;

          this.$alertMsg(errpr.response);
        });
    },
  },
};

const formats = {
  "af-ZA": "yyyy/MM/dd",
  "am-ET": "dd/MM/yyyy",
  "ar-AE": "dd/MM/yyyy",
  "ar-BH": "dd/MM/yyyy",
  "ar-DZ": "dd-MM-yyyy",
  "ar-EG": "dd/MM/yyyy",
  "ar-IQ": "dd/MM/yyyy",
  "ar-JO": "dd/MM/yyyy",
  "ar-KW": "dd/MM/yyyy",
  "ar-LB": "dd/MM/yyyy",
  "ar-LY": "dd/MM/yyyy",
  "ar-MA": "dd-MM-yyyy",
  "ar-OM": "dd/MM/yyyy",
  "ar-QA": "dd/MM/yyyy",
  "ar-SA": "dd/MM/yy",
  "ar-SY": "dd/MM/yyyy",
  "ar-TN": "dd-MM-yyyy",
  "ar-YE": "dd/MM/yyyy",
  "arn-CL": "dd-MM-yyyy",
  "as-IN": "dd-MM-yyyy",
  "az-Cyrl-AZ": "dd.MM.yyyy",
  "az-Latn-AZ": "dd.MM.yyyy",
  "ba-RU": "dd.MM.yy",
  "be-BY": "dd.MM.yyyy",
  "bg-BG": "dd.M.yyyy",
  "bn-BD": "dd-MM-yy",
  "bn-IN": "dd-MM-yy",
  "bo-CN": "yyyy/MM/dd",
  "br-FR": "dd/MM/yyyy",
  "bs-Cyrl-BA": "d.MM.yyyy",
  "bs-Latn-BA": "d.MM.yyyy",
  "ca-ES": "dd/MM/yyyy",
  "co-FR": "dd/MM/yyyy",
  "cs-CZ": "dd.MM.yyyy",
  "cy-GB": "dd/MM/yyyy",
  "da-DK": "dd-MM-yyyy",
  "de-AT": "dd.MM.yyyy",
  "de-CH": "dd.MM.yyyy",
  "de-DE": "dd.MM.yyyy",
  "de-LI": "dd.MM.yyyy",
  "de-LU": "dd.MM.yyyy",
  "dsb-DE": "dd.MM.yyyy",
  "dv-MV": "dd/MM/yy",
  "el-GR": "dd/MM/yyyy",
  "en-029": "MM/dd/yyyy",
  "en-AU": "d/MM/yyyy",
  "en-BZ": "dd/MM/yyyy",
  "en-CA": "dd/MM/yyyy",
  "en-GB": "dd/MM/yyyy",
  "en-IE": "dd/MM/yyyy",
  "en-IN": "dd-MM-yyyy",
  "en-JM": "dd/MM/yyyy",
  "en-MY": "dd/MM/yyyy",
  "en-NZ": "dd/MM/yyyy",
  "en-PH": "MM/dd/yyyy",
  "en-SG": "dd/MM/yyyy",
  "en-TT": "dd/MM/yyyy",
  "en-US": "MM/dd/yyyy",
  "en-ZA": "yyyy/MM/dd",
  "en-ZW": "MM/dd/yyyy",
  "es-AR": "dd/MM/yyyy",
  "es-BO": "dd/MM/yyyy",
  "es-CL": "dd-MM-yyyy",
  "es-CO": "dd/MM/yyyy",
  "es-CR": "dd/MM/yyyy",
  "es-DO": "dd/MM/yyyy",
  "es-EC": "dd/MM/yyyy",
  "es-ES": "dd/MM/yyyy",
  "es-GT": "dd/MM/yyyy",
  "es-HN": "dd/MM/yyyy",
  "es-MX": "dd/MM/yyyy",
  "es-NI": "dd/MM/yyyy",
  "es-PA": "MM/dd/yyyy",
  "es-PE": "dd/MM/yyyy",
  "es-PR": "dd/MM/yyyy",
  "es-PY": "dd/MM/yyyy",
  "es-SV": "dd/MM/yyyy",
  "es-US": "MM/dd/yyyy",
  "es-UY": "dd/MM/yyyy",
  "es-VE": "dd/MM/yyyy",
  "et-EE": "dd.MM.yyyy",
  "eu-ES": "yyyy/MM/dd",
  "fa-IR": "MM/dd/yyyy",
  "fi-FI": "dd.MM.yyyy",
  "fil-PH": "MM/dd/yyyy",
  "fo-FO": "dd-MM-yyyy",
  "fr-BE": "d/MM/yyyy",
  "fr-CA": "yyyy-MM-dd",
  "fr-CH": "dd.MM.yyyy",
  "fr-FR": "dd/MM/yyyy",
  "fr-LU": "dd/MM/yyyy",
  "fr-MC": "dd/MM/yyyy",
  "fy-NL": "dd-MM-yyyy",
  "ga-IE": "dd/MM/yyyy",
  "gd-GB": "dd/MM/yyyy",
  "gl-ES": "dd/MM/yy",
  "gsw-FR": "dd/MM/yyyy",
  "gu-IN": "dd-MM-yy",
  "ha-Latn-NG": "dd/MM/yyyy",
  "he-IL": "dd/MM/yyyy",
  "hi-IN": "dd-MM-yyyy",
  "hr-BA": "dd.MM.yyyy.",
  "hr-HR": "dd.MM.yyyy",
  "hsb-DE": "dd.MM.yyyy",
  "hu-HU": "yyyy.MM.dd.",
  "hy-AM": "dd.MM.yyyy",
  "id-ID": "dd/MM/yyyy",
  "ig-NG": "dd/MM/yyyy",
  "ii-CN": "yyyy/MM/dd",
  "is-IS": "dd.MM.yyyy",
  "it-CH": "dd.MM.yyyy",
  "it-IT": "dd/MM/yyyy",
  "iu-Cans-CA": "dd/MM/yyyy",
  "iu-Latn-CA": "dd/MM/yyyy",
  "ja-JP": "yyyy/MM/dd",
  "ka-GE": "dd.MM.yyyy",
  "kk-KZ": "dd.MM.yyyy",
  "kl-GL": "dd-MM-yyyy",
  "km-KH": "yyyy-MM-dd",
  "kn-IN": "dd-MM-yy",
  "ko-KR": "yyyy. MM. dd",
  "kok-IN": "dd-MM-yyyy",
  "ky-KG": "dd.MM.yy",
  "lb-LU": "dd/MM/yyyy",
  "lo-LA": "dd/MM/yyyy",
  "lt-LT": "yyyy.MM.dd",
  "lv-LV": "yyyy.MM.dd.",
  "mi-NZ": "dd/MM/yyyy",
  "mk-MK": "dd.MM.yyyy",
  "ml-IN": "dd-MM-yy",
  "mn-MN": "yy.MM.dd",
  "mn-Mong-CN": "yyyy/MM/dd",
  "moh-CA": "MM/dd/yyyy",
  "mr-IN": "dd-MM-yyyy",
  "ms-BN": "dd/MM/yyyy",
  "ms-MY": "dd/MM/yyyy",
  "mt-MT": "dd/MM/yyyy",
  "nb-NO": "dd.MM.yyyy",
  "ne-NP": "MM/dd/yyyy",
  "nl-BE": "dd/MM/yyyy",
  "nl-NL": "dd-MM-yyyy",
  "nn-NO": "dd.MM.yyyy",
  "nso-ZA": "yyyy/MM/dd",
  "oc-FR": "dd/MM/yyyy",
  "or-IN": "dd-MM-yy",
  "pa-IN": "dd-MM-yy",
  "pl-PL": "dd.MM.yyyy",
  "prs-AF": "dd/MM/yy",
  "ps-AF": "dd/MM/yy",
  "pt-BR": "dd/MM/yyyy",
  "pt-PT": "dd-MM-yyyy",
  "qut-GT": "dd/MM/yyyy",
  "quz-BO": "dd/MM/yyyy",
  "quz-EC": "dd/MM/yyyy",
  "quz-PE": "dd/MM/yyyy",
  "rm-CH": "dd/MM/yyyy",
  "ro-RO": "dd.MM.yyyy",
  "ru-RU": "dd.MM.yyyy",
  "rw-RW": "MM/dd/yyyy",
  "sa-IN": "dd-MM-yyyy",
  "sah-RU": "MM.dd.yyyy",
  "se-FI": "dd.MM.yyyy",
  "se-NO": "dd.MM.yyyy",
  "se-SE": "yyyy-MM-dd",
  "si-LK": "yyyy-MM-dd",
  "sk-SK": "dd.MM.yyyy",
  "sl-SI": "dd.MM.yyyy",
  "sma-NO": "dd.MM.yyyy",
  "sma-SE": "yyyy-MM-dd",
  "smj-NO": "dd.MM.yyyy",
  "smj-SE": "yyyy-MM-dd",
  "smn-FI": "dd.MM.yyyy",
  "sms-FI": "dd.MM.yyyy",
  "sq-AL": "yyyy-MM-dd",
  "sr-Cyrl-BA": "dd.MM.yyyy",
  "sr-Cyrl-CS": "dd.MM.yyyy",
  "sr-Cyrl-ME": "dd.MM.yyyy",
  "sr-Cyrl-RS": "dd.MM.yyyy",
  "sr-Latn-BA": "dd.MM.yyyy",
  "sr-Latn-CS": "dd.MM.yyyy",
  "sr-Latn-ME": "dd.MM.yyyy",
  "sr-Latn-RS": "dd.MM.yyyy",
  "sv-FI": "dd.MM.yyyy",
  "sv-SE": "yyyy-MM-dd",
  "sw-KE": "MM/dd/yyyy",
  "syr-SY": "dd/MM/yyyy",
  "ta-IN": "dd-MM-yyyy",
  "te-IN": "dd-MM-yy",
  "tg-Cyrl-TJ": "dd.MM.yy",
  "th-TH": "dd/MM/yyyy",
  "tk-TM": "dd.MM.yy",
  "tn-ZA": "yyyy/MM/dd",
  "tr-TR": "dd.MM.yyyy",
  "tt-RU": "dd.MM.yyyy",
  "tzm-Latn-DZ": "dd-MM-yyyy",
  "ug-CN": "yyyy-MM-dd",
  "uk-UA": "dd.MM.yyyy",
  "ur-PK": "dd/MM/yyyy",
  "uz-Cyrl-UZ": "dd.MM.yyyy",
  "uz-Latn-UZ": "dd/MM yyyy",
  "vi-VN": "dd/MM/yyyy",
  "wo-SN": "dd/MM/yyyy",
  "xh-ZA": "yyyy/MM/dd",
  "yo-NG": "dd/MM/yyyy",
  "zh-CN": "yyyy/MM/dd",
  "zh-HK": "dd/Mm/yyyy",
  "zh-MO": "dd/MM/yyyy",
  "zh-SG": "dd/MM/yyyy",
  "zh-TW": "yyyy/MM/dd",
  "zu-ZA": "yyyy/MM/dd",
};
